<template>
  <div>
    <stock-header ref="changestate"></stock-header>
    <div class="container">
      <el-row :gutter="10">
        <el-col :span="14">
          <div id="stockDetailed">
            <el-card class="box-card stockCard" shadow="never">
              <el-row>
                <el-col :span="24">
                  <h3 class="stockTitle">
                    &nbsp;&nbsp;{{ stocInfokData[1] }}&nbsp;&nbsp;<span
                      class="stockSubhead"
                      >({{ this.$route.query.symbol }})</span
                    >
                    <el-button
                      v-if="concernStatus"
                      type="primary"
                      plain
                      size="mini"
                      style="float: right; color: #000"
                      @click="join_concern"
                      >{{ $t('stock.addOptional') }}</el-button
                    >
                    <el-button
                      v-else
                      type="warning"
                      plain
                      size="mini"
                      style="float: right; color: #000"
                      @click="cancel_concern"
                      >{{ $t('stock.unselect') }}</el-button
                    >
                  </h3>
                </el-col>
                <el-col :span="7" class="stockInfoLeft">
                  <el-row>
                    <el-col :span="24" v-if="stocInfokData[31]">
                      <h3
                        class="trade green"
                        v-if="stocInfokData[31].substr(0, 1) === '-'"
                      >
                        {{ stocInfokData[3]
                        }}<i
                          class="el-icon-bottom"
                          style="font-weight: 900"
                        ></i>
                      </h3>
                      <h3 class="trade red" v-else>
                        {{ stocInfokData[3]
                        }}<i class="el-icon-top" style="font-weight: 900"></i>
                      </h3>
                    </el-col>
                    <el-col :span="24" v-if="stocInfokData[31]">
                      <el-row>
                        <el-col :span="12">
                          <div
                            class="pricechange green"
                            v-if="stocInfokData[31].substr(0, 1) === '-'"
                          >
                            <p>{{ stocInfokData[31] }}</p>
                          </div>
                          <div class="pricechange red" v-else>
                            <p>+{{ stocInfokData[31] }}</p>
                          </div>
                        </el-col>
                        <el-col :span="12">
                          <div
                            class="pricechange green"
                            v-if="stocInfokData[31].substr(0, 1) === '-'"
                          >
                            <p>{{ stocInfokData[32] }}%</p>
                          </div>
                          <div class="pricechange red" v-else>
                            <p>+{{ stocInfokData[32] }}%</p>
                          </div>
                        </el-col>
                      </el-row>

                      <el-col :span="24" v-if="stocInfokData[30]">
                        <p class="center stockTime">
                          {{
                            stocInfokData[30].slice(0, 4) +
                            "-" +
                            stocInfokData[30].slice(4, 6) +
                            "-" +
                            stocInfokData[30].slice(6, 8) +
                            " " +
                            stocInfokData[30].slice(8, 10) +
                            ":" +
                            stocInfokData[30].slice(10, 12) +
                            ":" +
                            stocInfokData[30].slice(12)
                          }}
                        </p>
                      </el-col>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="3">
                  <div class="stockInfoTitle text-right stockColor">
                    <p>{{ $t('stock.openToday') }}：</p>
                    <p>{{ $t('stock.highest') }}：</p>
                    <p>{{ $t('stock.lowest') }}：</p>
                    <p>{{ $t('stock.recievedYesterday') }}：</p>
                  </div>
                </el-col>
                <el-col :span="2">
                  <div class="stockInfoTitle text-left stockColor">
                    <p>{{ stocInfokData[5] }}</p>
                    <p>{{ stocInfokData[41] }}</p>
                    <p>{{ stocInfokData[42] }}</p>
                    <p>{{ stocInfokData[4] }}</p>
                  </div>
                </el-col>
                <el-col :span="2">
                  <div class="stockInfoTitle text-right stockColor">
                    <p>{{ $t('stock.volume') }}</p>
                    <p>{{ $t('stock.turnover') }}</p>
                    <p v-if="stocInfokData[45]">{{ $t('stock.totMarketCapitalize') }}</p>
                    <p v-if="stocInfokData[44]">{{ $t('stock.circulationValue') }}</p>
                  </div>
                </el-col>
                <el-col :span="4">
                  <div class="stockInfoTitle text-left stockColor">
                    <p>
                      {{
                        Number(
                          (stocInfokData[6] / 10000).toFixed(2)
                        ).toLocaleString(3)
                      }}{{ $t('stock.tenThousandYuan') }}
                    </p>
                    <p>
                      {{
                        Number(
                          (stocInfokData[37] / 10000).toFixed(2)
                        ).toLocaleString(3)
                      }}{{ $t('stock.hundredMilYuan') }}
                    </p>
                    <p v-if="stocInfokData[45]">{{ stocInfokData[45] }}{{ $t('stock.hundredMilYuan') }}</p>
                    <p v-if="stocInfokData[44]">{{ stocInfokData[44] }}{{ $t('stock.hundredMilYuan') }}</p>
                  </div>
                </el-col>
                <el-col :span="2">
                  <div class="stockInfoTitle text-right stockColor">
                    <p>{{ $t('stock.amplitude') }}：</p>
                    <p v-if="stocInfokData[38]">{{ $t('stock.turnoverRate') }}：</p>
                  </div>
                </el-col>
                <el-col :span="2">
                  <div class="stockInfoTitle text-left stockColor">
                    <p>{{ stocInfokData[43] }}%</p>
                    <p v-if="stocInfokData[38]">{{ stocInfokData[38] }}%</p>
                  </div>
                </el-col>
              </el-row>
            </el-card>
            <div id="kline">
              <!-- <Vue-kline
                :klineParams="klineParams"
                :klineData="klineData"
                ref="callMethods"
                @refreshKlineData="refreshKlineData"
              ></Vue-kline> -->
            </div>
            <NewKline></NewKline>
          </div>
        </el-col>
        <el-col :span="10">
          <stock-trading @changestockvalue="changestockvalue"></stock-trading>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import eventBus from "../assets/js/eventBus";
import StockHeader from "@/components/stockheader";
import NewKline from "@/components/newKline.vue";
import StockCard from "@/components/stockcard";
import VueKline from "vue-kline";
import $ from "jquery";
import StockTrading from "@/components/stocktrading";
import { Loading } from 'element-ui';

// import Kline from 'kline';

export default {
  name: "stockdetailed",
  components: {
    StockHeader,
    NewKline,
    StockCard,
    VueKline,
    StockTrading
  },
  props: ['range'],
  data() {
    return {
      klineParams: {
        width: 1000,
        height: 500,
        theme: "dark",
        language: "zh-cn",
        ranges: ["1w", "1d", "1h", "30m", "15m", "5m", "1m", "line"],
        symbol: this.$route.query.symbol,
        symbolName: '上证指数',
        intervalTime: 1000,
        depthWidth: 50,
        count: 1,
      },
      klineData: {},
      stocInfokData: [],
      screenwidth: '',
      concernStatus: true
    };
  },
  methods: {
    requestData(time) {
      let that = this;
      that
        .$http({
          url: "/app/Stock/kline",             //请求地址
          method: "POST",
          data: {
            'k': time,
            'symbol': this.$route.query.symbol
          }
        })
        .then(ret => {

          let resData = ret.data;

          let klineData = {};
          if (resData.status == 200) {
            klineData.success = true;
            klineData.data = {};
            klineData.data.lines = [];
            resData.data.lines = resData.data;
            for (let i = 0, len = resData.data.lines.length; i < len; i++) {
              resData.data.lines[i].splice(6);
              klineData.data.lines[i] = resData.data.lines[i];

              for (let j = 0, len2 = resData.data.lines[i].length; j < len2; j++) {
                switch (j) {
                  case 0:
                    if (time === '1d' || time === '1w') {
                      klineData.data.lines[i][j] = new Date(resData.data.lines[i][j].slice(0, 4) + '/' + resData.data.lines[i][j].slice(4, 6) + '/' + resData.data.lines[i][j].slice(6, 8) + ' ' + resData.data.lines[i][j].slice(8, 10) + ':' + resData.data.lines[i][j].slice(10)).getTime();
                    } else {
                      klineData.data.lines[i][j] = new Date(resData.data.lines[i][j].slice(0, 4) + '/' + resData.data.lines[i][j].slice(4, 6) + '/' + resData.data.lines[i][j].slice(6, 8) + ' ' + resData.data.lines[i][j].slice(8, 10) + ':' + resData.data.lines[i][j].slice(10)).getTime();
                    }
                    break;
                  case 1:
                    klineData.data.lines[i][j] = Number(resData.data.lines[i][j]);
                    break;
                  case 2:
                    klineData.data.lines[i][4] = Number(resData.data.lines[i][j]);
                    break;
                  case 3:
                    klineData.data.lines[i][2] = Number(resData.data.lines[i][j]);
                    break;
                  case 4:
                    klineData.data.lines[i][3] = Number(resData.data.lines[i][j]);
                    break;
                  default:
                    klineData.data.lines[i][j] = Number(resData.data.lines[i][j]);
                    break;

                }

              }
            }
          } else {
            klineData.success = false;
          }
          klineData.success = true;
          that.klineData = klineData;
          that.$refs.callMethods.kline.chartMgr.getChart().updateDataAndDisplay(klineData.data.lines);
          clearInterval(this.timer1);
          this.timer1 = setInterval(function () {
            that.klineData = {};
            that.requestData(that.$store.state.klineTime)
          }, 5000);
        });
    },
    refreshKlineData(option) {
      switch (option) {
        case 60000:
          this.$store.commit('changeKlineTime', '1m');
          this.requestData('1m');
          break;
        case 300000:
          this.$store.commit('changeKlineTime', '5m');
          this.requestData('5m');
          break;
        case 900000:
          this.$store.commit('changeKlineTime', '15m');
          this.requestData('15m');
          break;
        case 1800000:
          this.$store.commit('changeKlineTime', '30m');
          this.requestData('30m');
          break;
        case 3600000:
          this.$store.commit('changeKlineTime', '1h');
          this.requestData('1h');
          break;
        case 86400000:
          this.$store.commit('changeKlineTime', '1d');
          this.requestData('1d');
          break;
        case 604800000:
          this.$store.commit('changeKlineTime', '1w');
          this.requestData('1w');
          break;
      }
    },
    getStockInfo() {
      let that = this;
      let symbol = this.$route.query.symbol;
      $.ajax({
        url: "https://qt.gtimg.cn/q=" + symbol,
        type: "GET",
        dataType: "script",
        cache: true,
        success: function () {
          var elements = eval("v_" + symbol).split("~");
          that.stocInfokData = elements;
          that.$store.commit('addStocksVisited', { symbol: that.$route.query.symbol, symbolName: that.stocInfokData[1], trade: that.stocInfokData[3], changepercent: that.stocInfokData[32] });
          that.$refs.callMethods.setSymbol(that.$route.query.symbol, elements[1]);
        }
      });
      /*that
        .$http({
        url: "/",
        method: "POST",
        data: {
          'nozzle': 'stockdetail',
          'symbol': this.$route.query.symbol
        }
      })
        .then(ret => {
          let resData = ret.data;
          if (resData.code === 1){
            that.stocInfokData = resData.data;
            // this.KLine.setSymbol(that.$route.query.symbol,resData.data[1]);
            that.$refs.callMethods.setSymbol(that.$route.query.symbol,resData.data[1]);
            that.$store.commit('addStocksVisited',{symbol:that.$route.query.symbol,symbolName:that.stocInfokData[1],trade:that.stocInfokData[3],changepercent:that.stocInfokData[32]});
          }/!*else{
            that.$alert('请稍后尝试','提示',{
              confirmButtonText: '确定',
              callback: action => that.getStockInfo()
            })
          }*!/
        });*/
    },
    //加入自选
    join_concern() {
      let that = this;
      let symbol = this.$route.query.symbol.replace(/[^0-9]/ig, "");
      if (this.$store.state.loginType) {
        that.$http({
          url: "/app/Concern/join_concern",             //请求地址
          method: "POST",
          data: {
            'code': symbol
          }
        }).then(ret => {
          that.$message({
            message: that.$t(ret.data.msgId),
            type: "success",
            duration: 1000,
            onClose: function () {
              that.concernStatus = false;
              eventBus.$emit("concern");
            }
          });
        });
      } else {
        that.$message.error({
          message: that.$t('stock.notLoggedin'),
          onClose: function () {
            that.$router.push('/login')
          }
        });
      }

    },
    //取消自选
    cancel_concern() {
      let that = this;
      let symbol = this.$route.query.symbol.replace(/[^0-9]/ig, "");
      if (this.$store.state.loginType) {
        that.$http({
          url: "/app/Concern/cancel_concern",             //请求地址
          method: "POST",
          data: {
            'code': symbol
          }
        })
          .then(ret => {
            that.$message({
              message: that.$t(ret.data.msgId),
              type: "success",
              duration: 1000,
              onClose: function () {
                that.concernStatus = true;
              }
            });
          });
      } else {
        that.$message.error({
          message: that.$t('stock.notLoggedin'),
          onClose: function () {
            that.$router.push('/login')
          }
        });
      }
    },
    onResize(width, height) {

    },
    getUserConcern() {
      let that = this;
      that.$http({
        url: "/app/Concern/concern",
        method: "POST",
        data: {}
      }).then(ret => {
        let resData = ret.data;
        if (resData.code === 1) {
          let symbol = this.$route.query.symbol.replace(/[^0-9]/ig, "");
          let dataArr = resData.data;
          for (let i = 0, len = dataArr.length; i < len; i++) {
            if (symbol == dataArr[i].code) {
              that.concernStatus = false;
            }
          }
        }
      });
    },
    changestockvalue(value){
      this.$refs.changestate.updatestatus(value);
    },
  },
  mounted: function () {
    let that = this;
    // this.reload();
    if (that.$store.state.loginType) {
      this.getUserConcern();
    }
    this.getStockInfo();

    this.klineData = {};
    if (that.$store.state.accessNumber === 0) {
      that.$store.commit('changeAccessNumber')
    } else {
      that.requestData(that.$store.state.klineTime)
    }
    this.chatTimer = setInterval(function () {
      that.getStockInfo();
    }, 10000);
    this.$refs.callMethods.resize(document.getElementById('stockDetailed').clientWidth, 500);
    //持续
    window.onresize = function () {
      that.screenwidth = document.getElementById('stockDetailed').clientWidth;
      that.$refs.callMethods.resize(that.screenwidth, 500);
    }
  },
  watch: {
    $route(to, from) {
      //this.reload();
      this.requestData(this.$store.state.klineTime);
      this.getStockInfo();
    },
    /*screenwidth:{
      immediate:true,
      handler:function (value) {
        console.log(value);
      }
    }*/
  },
  beforeDestroy() {
    clearTimeout(this.chatTimer);
    clearTimeout(this.timer1);
  }
}
</script>

<style scoped>
.container {
  width: 100%;
  max-width: 1200px;
  min-width: 1000px;
  margin: 10px auto;
}
.stockCard {
  /* height: 160px; */
  margin-bottom: 10px;
  overflow: hidden;
  background: #040f1b;
  border-radius: 15px;
}
.stockTitle {
  color: #ffffff;
  font-size: 20px;
  font-weight: 500;
  border-bottom: 1px solid #dfe3e8;
  padding-bottom: 10px;
}
.stockSubhead {
  font-size: 12px;
}
.trade {
  text-align: center;
  font-size: 34px;
  font-weight: 500;
  /* border-bottom: 1px solid #EBEEF5; */
  padding-top: 15px;
  padding-bottom: 10px;
}
.stockInfoLeft {
  /* border-right: 1px solid #EBEEF5; */
}
.pricechange {
  padding-top: 10px;
  padding-bottom: 10px;
  font-size: 22px;
  /* border-bottom: 1px solid #EBEEF5; */
}
.stockTime {
  padding-top: 10px;
  font-size: 12px;
  color: rgb(1, 39, 147);
  padding-bottom: 20px;
}
.stockInfoTitle {
  font-size: 12px;
  padding-top: 10px;
  line-height: 20px;
}
.text-right {
  text-align: right;
}
.text-left {
  text-align: left;
}
.green {
  color: #008000;
}
.stockColor {
  color: #feffff;
}
.m-line {
  width: 100%;
  height: 500px;
}
.K-line {
  width: 100%;
  height: 500px;
}
#kline >>> .chart_container {
  background-color: #161616;
  border-radius: 15px;
}
#kline >>> .chart_container.dark #chart_toolbar {
  height: 35px !important;
}
#kline >>> .chart_container.dark .chart_dropdown_t {
  border: 2px solid var(--baseColor);
  /* margin: 5px 5px 5px; */
  border-radius: 5px;
}
#kline >>> .chart_container.dark .chart_dropdown_t:hover {
  border-bottom: none;
  border-radius: 5px 5px 0 0;
}
</style>




// WEBPACK FOOTER //
// src/components/stockdetailed.vue